import { ExclamationCircleOutlined } from '@ant-design/icons';
import { Modal, Space, Typography } from 'antd';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import styles from './styles.module.scss';

import Button from '../Button';

const { Text } = Typography;

type UnsavedChangesModalProps = {
  isOpen: boolean;
  onStay: () => void;
  onDiscard: () => void;
  onSaveAndLeave?: () => Promise<void>;
  canSaveAndLeave?: boolean;
  isSaving?: boolean;
};

export const UnsavedChangesModal: FC<UnsavedChangesModalProps> = ({
  isOpen,
  onStay,
  onDiscard,
  onSaveAndLeave,
  canSaveAndLeave = false,
  isSaving = false,
}) => {
  const { t } = useTranslation('common.UnsavedChangesModal');

  return (
    <Modal
      open={isOpen}
      onCancel={onStay}
      closable={false}
      maskClosable={false}
      footer={null}
      centered
      width={400}
    >
      <div className={styles.content}>
        <ExclamationCircleOutlined className={styles.icon} />

        <Typography.Title level={4} className={styles.title}>
          {t('title')}
        </Typography.Title>

        <Text type="secondary" className={styles.message}>
          {t('message')}
        </Text>

        <Space direction="vertical" size="small" className={styles.actions}>
          <Button type="primary" block onClick={onStay}>
            {t('stayOnPage')}
          </Button>

          {canSaveAndLeave && onSaveAndLeave && (
            <Button block onClick={onSaveAndLeave} loading={isSaving}>
              {t('saveAndLeave')}
            </Button>
          )}

          <Button danger block onClick={onDiscard} disabled={isSaving}>
            {t('discard')}
          </Button>
        </Space>
      </div>
    </Modal>
  );
};
